var Data =  [
    {
        "id":1,
        "name": "关于放假的通知1.pdf",
        "cover" : require("@/assets/images/file_cover.png"),
    },
    {
        "id":2,
        "name": "关于复课的通知1.pdf",
        "cover" : require("@/assets/images/file_cover.png"),
      }
  ]
  
  module.exports = {
    likeData: Data,
  };


// WEBPACK FOOTER //
// ./src/assets/data/likeData.js